import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export function parseCmrDob(dobStr) {
  if (!dobStr) return '';
  const trimmed = String(dobStr).trim();
  const formats = ['DD-MMM-YYYY', 'DD-MMM-YY', 'YYYY-MM-DD', 'DD/MM/YYYY'];
  for (const format of formats) {
    const parsed = dayjs(trimmed, format, true);
    if (parsed.isValid()) return parsed.format('YYYY-MM-DD');
  }
  const fallback = dayjs(trimmed);
  return fallback.isValid() ? fallback.format('YYYY-MM-DD') : '';
}
